import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchTickerData } from '../api/tickersApi';
import { selectAllTickerAttrs } from '../store/slices/tickers.slice';
import _ from 'lodash';

export const useTickerData = (symbols, fields, collection) => {
  const dispatch = useDispatch();
  const tickerData = useSelector(state => selectAllTickerAttrs(state, symbols, fields));
  const allTickers = useSelector(state => state.tickers.tickers);
  const requestedRef = useRef({});

  useEffect(() => {
    if (!symbols || symbols.length === 0 || !fields || fields.length === 0) return;
    const missingSymbols = symbols.filter(symbol =>
      !allTickers[symbol] || fields.some(field => !_.has(allTickers[symbol], field))
    );

    const missingFields = fields.filter(field =>
      symbols.some(symbol => !allTickers[symbol] || !_.has(allTickers[symbol], field))
    );

    const requestKey = `${missingSymbols.join(',')}-${missingFields.join(',')}-${collection}`;

    if (missingSymbols.length > 0 && missingFields.length > 0 && !requestedRef.current[requestKey]) {
      requestedRef.current[requestKey] = true;
      dispatch(fetchTickerData({ symbols: missingSymbols, fields: missingFields, collection }));
    }
  }, [symbols, fields, collection, dispatch, allTickers]);

  return tickerData;
};
